// Единый модуль уведомлений (звук, mute, громкость, персист в LS)
const KEY = 'notify.settings';

function load() {
    try {
        const raw = localStorage.getItem(KEY);
        if (raw) return JSON.parse(raw);
    } catch { }
    return { enabled: true, volume: 0.6 };
}
function save(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { }
}

const state = load();
let ctx = null;
let unlocked = false;

function ensureCtx() {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
    }
    return ctx;
}

// Разрешаем звук ТОЛЬКО после жеста пользователя, чтобы не было варнинга
function unlock() {
    if (unlocked) return;
    const resume = async () => {
        const c = ensureCtx();
        if (c && c.state === 'suspended') {
            try { await c.resume(); } catch { }
        }
        unlocked = true;
        window.removeEventListener('click', resume);
        window.removeEventListener('keydown', resume);
        window.removeEventListener('touchstart', resume);
    };
    window.addEventListener('click', resume);
    window.addEventListener('keydown', resume);
    window.addEventListener('touchstart', resume, { passive: true });
}

function beep() {
    if (!state.enabled) return;
    const c = ensureCtx();
    if (!c || c.state === 'suspended') return; // не насилуем контекст — иначе warning
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = 'sine';
    o.frequency.value = 920;
    g.gain.value = 0;
    o.connect(g);
    g.connect(c.destination);
    const t = c.currentTime;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.08 * Math.max(0, Math.min(1, state.volume || 0)), t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.25);
    o.start(t);
    o.stop(t + 0.3);
}

function setEnabled(v) { state.enabled = !!v; save(state); }
function toggle() { setEnabled(!state.enabled); }
function setVolume(v) { state.volume = Math.max(0, Math.min(1, Number(v) || 0)); save(state); }
function get() { return { ...state }; }

export const notify = { unlock, beep, setEnabled, setVolume, toggle, get };
